import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useUserLocation} from 'modules/locations/hooks/useUserLocation';
import {getDeliveryInfo} from 'modules/product-card/thunks';
import {ProductDetail} from 'new-models';
import {useEffect} from 'react';

export const useProductDeliveryInfo = (productIds?: ProductDetail['id'][] | null, locationId?: string) => {
    const dispatch = useAppDispatch();
    const userLocation = useUserLocation();
    const locationIdToUse = locationId ?? userLocation?.id;

    useEffect(() => {
        if (locationIdToUse) {
            dispatch(getDeliveryInfo(locationIdToUse, productIds));
        }
    }, [productIds, locationIdToUse, dispatch]);
};
